const QUERIES = {
  INVOICES_LIST: 'invoices-list',
  COMPANIES_LIST: 'companies-list',
  CUSTOMERS_LIST: 'customers-list',
  EBTALS_LIST: 'ebtals-list',
  PRODUCTS_LIST: 'products-list',
  STUFFIDS_LIST: 'stuffids-list',
  TAXPAYERS_LIST: 'transactionrecords-list',
  TRANSACTIONRECORDS_LIST: 'transactionrecords-list',
  TICKETS_LIST: 'tickets-list',
  STUFFIDFILETAGS_LIST: 'stuffidFileTags-list',
  LOGS_LIST: 'logs-list',
  SMS_LOGS_LIST: 'sms-logs-list',
}

export {QUERIES}
